<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 74 49.264">
    <g id="yema10" transform="translate(-66 -684)">
      <text id="_01" data-name="01" transform="translate(86 721)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
      <rect id="矩形_2891" data-name="矩形 2891" width="49.264" height="3" transform="translate(77 684) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2895" data-name="矩形 2895" width="49.264" height="3" transform="translate(132 684) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2893" data-name="矩形 2893" width="34.264" height="3" transform="translate(69 692) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2894" data-name="矩形 2894" width="34.264" height="3" transform="translate(140 692) rotate(90)" fill="var(--theme-color-1)"/>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
